'use strict';

var Backbone = require('backbone');
var Radio = require('backbone.radio');
var _ = require('underscore');

export default Backbone.Collection.extend({

  initialize: function () {
    this.enabled = true;
    this.currentIndex = 0;
    this.previousSlug = '';

    Radio.channel('steps').reply('list', this.toJSON, this);
    Radio.channel('steps').reply('current', this.getCurrent, this);
    Radio.channel('steps').reply('next', this.getNext, this);
    Radio.channel('steps').reply('previous', this.getPrevious, this);
    Radio.channel('steps').reply('previousSlug', this.getPreviousSlug, this);
    Radio.channel('steps').reply('start', this.getStart, this);
    Radio.channel('steps').reply('currentIndex', this.getCurrentIndex, this);
    Radio.channel('steps').reply('count', function () {
      return this.length;
    }, this);
    Radio.channel('steps').reply('first', this.isFirst, this);
    Radio.channel('steps').reply('last', this.isLast, this);
    Radio.channel('steps').reply('enabled', this.isEnabled, this);

    Radio.channel('steps').on('back', this.back, this);
    Radio.channel('steps').on('next', this.next, this);
    Radio.channel('steps').on('on', this.on, this);
    Radio.channel('steps').on('off', this.off, this);

    Radio.channel('steps').on('current', this.setCurrent, this);
    Radio.channel('steps').on('remove', this.removeBySlug, this);
  },

  getCurrent: function () {
    return this.at(this.currentIndex);
  },

  getNext: function () {
    if (this.isLast()) {
      return false;
    }
    return this.at(this.currentIndex + 1);
  },

  getPrevious: function (slug) {
    var index = _.indexOf(this.pluck('slug'), slug);
    if (index === 0) {
      return false;
    }
    return this.at(index - 1);
  },

  getPreviousSlug: function () {
    return this.previousSlug;
  },

  getStart: function () {
    return this.at(0);
  },

  getCurrentIndex: function () {
    return this.currentIndex;
  },

  isFirst: function (slug) {
    if (slug) {
      var index = _.indexOf(this.pluck('slug'), slug);
      return index === 0;
    }
    return (this.currentIndex === 0);
  },

  isLast: function () {
    return (this.currentIndex === (this.length - 1));
  },

  isEnabled: function () {
    return this.enabled;
  },

  rewind: function () {
    this.currentIndex = 0;
    Radio.channel('steps').trigger('change:current');
  },

  back: function () {
    if (this.currentIndex > 0) {
      this.previousSlug = Radio.channel('steps').request('current').get('slug');
      this.currentIndex--;
      Radio.channel('steps').trigger('change:current');
    }
  },

  next: function () {
    if (this.currentIndex < this.length - 1) {
      this.previousSlug = Radio.channel('steps').request('current').get('slug');
      this.currentIndex++;
      Radio.channel('steps').trigger('change:current');
    }
  },

  on: function () {
    this.enabled = true;
    Radio.channel('steps').trigger('change:enabled');
  },

  off: function () {
    this.enabled = false;
    Radio.channel('steps').trigger('change:enabled');
  },

  setCurrent: function (slug) {
    this.currentIndex = _.indexOf(this.pluck('slug'), slug);

    Radio.channel('steps').trigger('change:current');
  },

  removeBySlug: function (slug) {
    this.remove(this.findWhere({slug: slug}));
    Radio.channel('steps').trigger('removed');
  },

});
